import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark-ready",
  "use": "icon-checkmark-ready-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkmark-ready\">\n<circle cx=\"12\" cy=\"12\" r=\"12\" transform=\"rotate(90 12 12)\" fill=\"#36B27E\" />\n<path d=\"M6 12.0003L10 16L18 8.00033\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol